(function($){
	/* 緊急対応用のスペースです。 次回リリース等で正式なコードに移し替えてください。 */

	// 2016.04.24 MORI_WEB_BA-50
	/*
	$(function(){
		$('[data-rendering-watch]').find('option[value=""]').each(function(){
			$(this).text("＜" + $(this).text().replace(/・全て/g, "") + "＞");
			$('<option>').attr("value", OH.idPrefix).text("指定なし").insertAfter($(this));
		});
	});
	*/
})(jQuery);
